import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const MenuIcon = ({ className, color }: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 17.2 11.2'
      className={className || 'rf-w-4 rf-h-4'}
    >
      <path
        d='M4,17H20M4,12H20M4,7H20'
        transform='translate(-3.4 -6.4)'
        fill='none'
        stroke={color || '#FFF'}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.2'
      />
    </svg>
  )
}

export default MenuIcon
